<template>
  <div class="text-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="图标设置"
          name="2"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
            <div>播放图标</div>
            <div class="img_up content">
              <img-icon-upload
                class="mb16"
                :imgSrc.sync="iconPlaySrc"
                :iconType.sync="iconPlayType"
                :iconColor.sync="iconPlayColor"
                :showDel="false"
                :resInfo.sync="resPlayInfo"
                :resourceShow="false"
              />
            </div>
            <div>暂停图标</div>
            <div class="img_up content">
              <img-icon-upload
                :imgSrc.sync="iconPauseSrc"
                :iconType.sync="iconPauseType"
                :iconColor.sync="iconPauseColor"
                :showDel="false"
                :resInfo.sync="resPauseInfo"
                :resourceShow="false"
              />
            </div>
            <div class="mt16" v-if="showControls">快进图标</div>
            <div class="img_up content" v-if="showControls">
              <img-icon-upload
                :imgSrc.sync="iconFastSrc"
                :iconType.sync="iconPauseType"
                :iconColor.sync="iconPauseColor"
                :showDel="false"
                :resourceShow="false"
              />
            </div>
            <div class="mt16" v-if="showControls">后退图标</div>
            <div class="img_up content" v-if="showControls">
              <img-icon-upload
                :imgSrc.sync="iconBackSrc"
                :iconType.sync="iconPauseType"
                :iconColor.sync="iconPauseColor"
                :showDel="false"
                :resourceShow="false"
              />
            </div>
            <slider-and-input
              v-if="showControls"
              class="mt16"
              inputWidth="small"
              inputHeight="small"
              :value.sync="buttonIconSize"
              title="大小"
              :sliderMax="100"
              suffix="px"
            />
            <slider-and-input
              v-if="showControls"
              class="mt16"
              inputWidth="small"
              inputHeight="small"
              :value.sync="iconMargin"
              title="间距"
              :sliderMax="100"
              suffix="px"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item
          v-if="showControls"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
          title="进度条设置"
          name="6"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')">
            <el-collapse v-model="activeNamesSub" class="sub-collapse">
              <el-collapse-item name="1" title="进度条">
                <slider-and-input
                  class="mt16"
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="progressbarHeight"
                  title="高度"
                  :sliderMax="100"
                  suffix="px"
                />
                <cx-background :background.sync="barBackground" imgType="10" class="mt16" infoTips="进度条背景"/>
                <cx-background :background.sync="progressBackground" imgType="10" class="mt16" infoTips="播放进度背景"/>
                <div class="content-item mt16">
                  <border-radius
                    :borderTypeFlag.sync="barBorderTypeFlag"
                    :borderRadius.sync="barBorderRadius"
                    :borderTopLeftRadius.sync="barBorderTopLeftRadius"
                    :borderTopRightRadius.sync="barBorderTopRightRadius"
                    :borderBottomRightRadius.sync="barBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="barBorderBottomLeftRadius"
                    :sliderMax="paddingMax"
                  />
                </div>
                <div class="content-item mt16">
                  <div class="mb16">边框</div>
                  <cx-border
                    :borderWidth.sync="barBorderWidth"
                    :borderStyle.sync="barBorderStyle"
                    :borderColor.sync="barBorderColor"
                    :borderIsThemeColor.sync="barBorderIsThemeColor"
                  />
                </div>
              </el-collapse-item>
              <el-collapse-item name="2" title="滑块">
                <slider-and-input
                  class="mt16"
                  inputWidth="small"
                  inputHeight="small"
                  :value.sync="symbolSize"
                  title="大小"
                  :sliderMax="100"
                  suffix="px"
                />
                <div class="verticallyCenter mt16">
                  <span class="mr16">颜色</span>
                  <cx-color-picker
                    class="flex1"
                    :isThemeColor.sync="sliderIconIsThemeColor"
                    :colorArr.sync="sliderIconColor"
                    >
                  </cx-color-picker>
                </div>
                <div class="content-item mt16">
                  <border-radius
                    :borderTypeFlag.sync="thumbsBorderTypeFlag"
                    :borderRadius.sync="thumbsBorderRadius"
                    :borderTopLeftRadius.sync="thumbsBorderTopLeftRadius"
                    :borderTopRightRadius.sync="thumbsBorderTopRightRadius"
                    :borderBottomRightRadius.sync="thumbsBorderBottomRightRadius"
                    :borderBottomLeftRadius.sync="thumbsBorderBottomLeftRadius"
                    :sliderMax="paddingMax"
                  />
                </div>
                <div class="content-item mt16">
                  <div class="mb16">边框</div>
                  <cx-border
                    :borderWidth.sync="thumbsBorderWidth"
                    :borderStyle.sync="thumbsBorderStyle"
                    :borderColor.sync="thumbsBorderColor"
                    :borderIsThemeColor.sync="thumbsBorderIsThemeColor"
                  />
                </div>
                <div class="content-item">
                  <div class="checkbox_colorPicker_container">
                    <span>阴影</span>
                    <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadowThumbs"></span>
                  </div>
                  <box-shadow
                    :boxShadowH.sync="thumbsBoxShadowH"
                    :boxShadowV.sync="thumbsBoxShadowV"
                    :boxShadowBlur.sync="thumbsBoxShadowBlur"
                    :boxShadowSpread.sync="thumbsBoxShadowSpread"
                    :boxShadowColor.sync="thumbsBoxShadowColor"
                  ></box-shadow>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-collapse-item>
        <el-collapse-item
          v-if="showControls"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
          title="时间文字设置"
          name="7"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')">
            <text-setting-update
              :fontColor.sync="timeColor"
              :fontFamily.sync="timeFontFamily"
              :fontSize.sync="otherFontSize"
              :fontWeight.sync="timeFontWeight"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="播放设置"
          name="3"
        >
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
            <!-- <cx-check-box :value.sync="autoplayStatus">自动播放</cx-check-box> -->
            <cx-check-box class="mt8" :value.sync="loopPlay">循环播放</cx-check-box>
          </div>
          <!-- <big-screen-animate-set></big-screen-animate-set> -->
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')" title="外观" name="4">
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
            <slider-and-input
              class="mb16"
              inputWidth="small"
              inputHeight="small"
              :value.sync="opacity"
              title="透明度"
              :sliderMax="100"
              suffix="%"
            />
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              class="mb16"
              v-if="request_prefix !== 'bigScreen'"
            />
            <div class="content-item mb16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                :sliderMax="paddingMax"
              />
            </div>
            <div class="content-item mb16">
              <div class="mb16">边框</div>
              <cx-border
                :borderWidth.sync="borderWidth"
                :borderStyle.sync="borderStyle"
                :borderColor.sync="borderColor"
                :borderIsThemeColor.sync="borderIsThemeColor"
              />
            </div>
            <div class="content-item mb16">
              <cx-background :background.sync="background" imgType="10" />
            </div>
            <div class="content-item">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" title="边距" name="5">
          <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
            <cx-padding
              :paddingTypeFlag.sync="paddingTypeFlag"
              :padding.sync="legendPadding"
              :paddingTop.sync="paddingTop"
              :paddingRight.sync="paddingRight"
              :paddingBottom.sync="paddingBottom"
              :paddingLeft.sync="paddingLeft"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex"
import TextSettingComplex from "modules/components/textSettingComplex"
import defaultImgBg from "assets/images/empty_img_bg.png"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  name: "video-options-data",
  components: {
    TextSettingComplex,
    controlWidthAndSizeAndZindex,
    widthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "6"],
      allCollapseNames: ["4", "5", "6", "7"],
      collapseActiveNames: ["1", "2", "3", "6"],
      activeType: 1,
      sliderMax: 360,
      paddingMax: 200,
      defaultImgBg: defaultImgBg,
      labelTrue: true,
      labelFalse: false,
      // 边距设置
      paddingTypeFlag: 1,
      activeNamesSub: ["1","2"]
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    isDraggable() {
      if (this.options && !this.options.hasOwnProperty("draggable")) {
        return true
      }
      return this.options.draggable
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    iconPlaySrc: {
      get() {
        return this.options.iconPlaySrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPlaySrc", false)
      }
    },
    iconPauseSrc: {
      get() {
        return this.options.iconPauseSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPauseSrc", false)
      }
    },
    iconPlayType: {
      get() {
        return this.options.iconPlayType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPlayType", false)
      }
    },
    iconPauseType: {
      get() {
        return this.options.iconPauseType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPauseType", false)
      }
    },
    iconPlayColor: {
      get() {
        return this.options.iconPlayColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPlayColor", false)
      }
    },
    iconPauseColor: {
      get() {
        return this.options.iconPauseType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconPauseType", false)
      }
    },
    iconFastSrc: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconFastSrc", "iconFastSrc", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconFastSrc", false)
      }
    },
    iconBackSrc: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconBackSrc", "iconBackSrc", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconBackSrc", false)
      }
    },
    // 边框样式
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    // 循环播放
    loopPlay: {
      get() {
        return this.options.loopPlay
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loopPlay", false)
      }
    },
    // 自动播放
    autoplayStatus: {
      get() {
        return this.options.autoplayStatus
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "muted", false)
        this.$changeOptionsEV(newVal, "autoplayStatus", false)
      }
    },
    mutedStatus: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "muted", "muted", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "muted", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    // 边距
    legendPadding: {
      get() {
        return this.options.legendPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "legendPadding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    // rotate: {
    //   get() {
    //     return parseInt(this.options.rotate)
    //   },
    //   set(newVal) {
    //     this.$changeOptionsEV(newVal + "deg", "rotate", false)
    //   }
    // },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    opacity: {
      get() {
        return this.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    resPlayInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resPlayInfo", "resPlayInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resPlayInfo", false)
      }
    },
    resPauseInfo: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "resPauseInfo", "resPauseInfo", {})
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "resPauseInfo", false)
      }
    },
    buttonIconSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "buttonIconSize", "buttonIconSize", 40)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconSize", false)
      }
    },
    iconMargin: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iconMargin", "iconMargin", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconMargin", false)
      }
    },
    symbolSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "symbolSize", "symbolSize", 16)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "symbolSize", false)
      }
    },
    sliderIconIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "sliderIconIsThemeColor", "sliderIconIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "sliderIconIsThemeColor", false)
      }
    },
    sliderIconColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "sliderIconColor", "sliderIconColor", "#ffffff")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "sliderIconColor", false)
      }
    },
    progressbarHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "progressbarHeight", "progressbarHeight", 6)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "progressbarHeight", false)
      }
    },
    barBackground: {
      get() {
        let background = this.options.barBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.barBackground
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBackground", false)
      }
    },
    progressBackground: {
      get() {
        let background = this.options.progressBackground
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.progressBackground
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "progressBackground", false)
      }
    },
    barBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("barBorderTypeFlag")) {
          if (
            ((this.barBorderTopLeftRadius === this.barBorderTopRightRadius) === this.barBorderBottomLeftRadius) ===
            this.barBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "barBorderTypeFlag", "barBorderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderTypeFlag", false)
      }
    },
    barBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderRadius", "barBorderRadius", this.barBorderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.barBorderTopLeftRadius = newVal
          this.barBorderTopRightRadius = newVal
          this.barBorderBottomLeftRadius = newVal
          this.barBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "barBorderRadius", false)
      }
    },
    barBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderTopLeftRadius", "barBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderTopLeftRadius", false)
      }
    },
    barBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderTopRightRadius", "barBorderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderTopRightRadius", false)
      }
    },
    barBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderBottomRightRadius", "barBorderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderBottomRightRadius", false)
      }
    },
    barBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderBottomLeftRadius", "barBorderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderBottomLeftRadius", false)
      }
    },
    barBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderIsThemeColor", "barBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderIsThemeColor", false)
      }
    },
    barBorderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderStyle", "barBorderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderStyle", false)
      }
    },
    barBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderWidth", "barBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderWidth", false)
      }
    },
    barBorderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "barBorderColor", "barBorderColor", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "barBorderColor", false)
      }
    },
    thumbsBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("thumbsBorderTypeFlag")) {
          if (
            ((this.thumbsBorderTopLeftRadius === this.thumbsBorderTopRightRadius) === this.thumbsBorderBottomLeftRadius) ===
            this.thumbsBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderTypeFlag", "thumbsBorderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderTypeFlag", false)
      }
    },
    thumbsBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderRadius", "thumbsBorderRadius", this.thumbsBorderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.thumbsBorderTopLeftRadius = newVal
          this.thumbsBorderTopRightRadius = newVal
          this.thumbsBorderBottomLeftRadius = newVal
          this.thumbsBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "thumbsBorderRadius", false)
      }
    },
    thumbsBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderTopLeftRadius", "thumbsBorderTopLeftRadius", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderTopLeftRadius", false)
      }
    },
    thumbsBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderTopRightRadius", "thumbsBorderTopRightRadius", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderTopRightRadius", false)
      }
    },
    thumbsBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderBottomRightRadius", "thumbsBorderBottomRightRadius", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderBottomRightRadius", false)
      }
    },
    thumbsBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderBottomLeftRadius", "thumbsBorderBottomLeftRadius", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderBottomLeftRadius", false)
      }
    },
    thumbsBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderIsThemeColor", "thumbsBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderIsThemeColor", false)
      }
    },
    thumbsBorderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderStyle", "thumbsBorderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderStyle", false)
      }
    },
    thumbsBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderWidth", "thumbsBorderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderWidth", false)
      }
    },
    thumbsBorderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBorderColor", "thumbsBorderColor", "")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBorderColor", false)
      }
    },
    thumbsBoxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBoxShadowColor", "thumbsBoxShadowColor", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowColor", false)
      }
    },
    thumbsBoxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBoxShadowH", "thumbsBoxShadowH", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowH", false)
      }
    },
    thumbsBoxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBoxShadowV", "thumbsBoxShadowV", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowV", false)
      }
    },
    thumbsBoxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBoxShadowBlur", "thumbsBoxShadowBlur", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowBlur", false)
      }
    },
    thumbsBoxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "thumbsBoxShadowSpread", "thumbsBoxShadowSpread", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thumbsBoxShadowSpread", false)
      }
    },
    timeFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "timeFontFamily", "timeFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "timeFontFamily", false)
      }
    },
    otherFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "otherFontSize", "otherFontSize", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "otherFontSize", false)
      }
    },
    timeFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "timeFontWeight", "timeFontWeight", "400")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "timeFontWeight", false)
      }
    },
    timeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "timeColor", "timeColor", "rgba(0, 0, 0, 0.8)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "timeColor", false)
      }
    },
    showControls() {
      return this.options.hasOwnProperty("showControls") ? this.options.hasOwnProperty("showControls") : false
    }
  },
  methods: {
    changeVideoPaddingType(value) {
      this.paddingTypeFlag = value
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    addBoxshadowThumbs() {
      if (!Array.isArray(this.thumbsBoxShadowH)) {
        this.thumbsBoxShadowH = [this.thumbsBoxShadowH]
        this.thumbsBoxShadowV = [this.thumbsBoxShadowV]
        this.thumbsBoxShadowBlur = [this.thumbsBoxShadowBlur]
        this.thumbsBoxShadowSpread = [this.thumbsBoxShadowSpread]
        this.thumbsBoxShadowColor = [this.thumbsBoxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.thumbsBoxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.thumbsBoxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.thumbsBoxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.thumbsBoxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.thumbsBoxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.thumbsBoxShadowH = boxShadowH
      this.thumbsBoxShadowV = boxShadowV
      this.thumbsBoxShadowBlur = boxShadowBlur
      this.thumbsBoxShadowSpread = boxShadowSpread
      this.thumbsBoxShadowColor = boxShadowColor
    },
  }
})
</script>

<style scoped>
.el-radio {
  margin-right: 20px;
  margin-bottom: 0px !important;
}
.el-radio:nth-child(2n) {
  margin-right: 0;
}
.img_up {
  margin-top: 8px;
}
.video-start-btn-setting {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.flex_box {
  display: flex;
  align-items: center;
}

.data-source-type .bigScreen .toolbar .el-radio__label {
  margin-left: 0px;
}
.dialog-play-mode > span {
  display: inline-block;
  vertical-align: top;
}

.dialog-play-mode .data-source-type {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 72px);
}

.video-border-setting > div:first-child {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 40px);
}
.video-border-color {
  display: inline-block;
  vertical-align: bottom;
  width: 32px;
  margin-left: 8px;
}
.video-border-color ::v-deep .text_color_in_input {
  display: none;
}
.bigScreen .toolbar .dialog-play-setting ::v-deep .el-radio__label {
  margin-left: 0;
}

.boxshadow-wrap {
  z-index: 9999;
}
.sub-collapse ::v-deep .el-collapse-item {
  background-color: transparent !important;
}
.toolbar .el-tabs .sub-collapse ::v-deep .el-collapse-item__header{
  height: 24px;
  padding-left: 18px !important;
  background: transparent !important;
  font-weight: 400;
}
.sub-collapse ::v-deep .el-collapse-item__wrap .el-collapse-item__content {
  padding-left: 18px !important;
}
.sub-collapse ::v-deep .el-collapse-item__header .el-collapse-item__arrow {
  left: 0 !important;
}
</style>
